import { token } from '@terra/ui-styled-system';
import {
  BotIcon,
  Brain01Icon,
  Database01Icon,
  GitBranchIcon,
  HierarchyIcon,
  Layers01Icon,
  MemoryStickIcon,
  Message01Icon,
  PackageIcon,
  SecurityCheckIcon,
  Wrench01Icon,
  type TerraIcon,
} from '@terra/ui-icons';

type AiAttackPathMark = {
  icon: TerraIcon;
  bg: string;
  color: string;
  borderColor: string;
  edge: string;
};

const infoMark = {
  bg: 'bg.info.subtle',
  color: 'fg.info',
  borderColor: 'border.info.muted',
  edge: token('colors.fg.info'),
} as const;

const successMark = {
  bg: 'bg.success.subtle',
  color: 'fg.success',
  borderColor: 'border.success.muted',
  edge: token('colors.fg.success'),
} as const;

const warningMark = {
  bg: 'bg.warning.subtle',
  color: 'fg.warning',
  borderColor: 'border.warning.muted',
  edge: token('colors.fg.warning'),
} as const;

const purpleMark = {
  bg: 'bg.purple.subtle',
  color: 'fg.purple',
  borderColor: 'border.purple.muted',
  edge: token('colors.violet.10'),
} as const;

const mutedMark = {
  bg: 'bg.neutral.subtle',
  color: 'fg.muted',
  borderColor: 'border.neutral.muted',
  edge: token('colors.fg.muted'),
} as const;

export const AI_ATTACK_PATH_MARKS: Record<string, AiAttackPathMark> = {
  AGENT: { ...infoMark, icon: BotIcon },
  SUB_AGENT: { ...infoMark, icon: BotIcon },
  TOOL: {
    icon: Wrench01Icon,
    bg: 'bg.entity.assets',
    color: 'fg.default',
    borderColor: 'border.entity.asset',
    edge: token('colors.fg.entity.assets'),
  },
  MCP_SERVER: { ...successMark, icon: HierarchyIcon },
  MCP_TOOL: { ...successMark, icon: Wrench01Icon },
  MCP_PROMPT: { ...infoMark, icon: Message01Icon },
  MCP_RESOURCE: { ...warningMark, icon: PackageIcon },
  MCP_PROTOCOL: { ...purpleMark, icon: Layers01Icon },
  RAG: { ...warningMark, icon: Database01Icon },
  MODEL: { ...purpleMark, icon: Brain01Icon },
  MEMORY: { ...mutedMark, icon: MemoryStickIcon },
  GUARDRAIL: {
    icon: SecurityCheckIcon,
    bg: 'bg.danger.subtle',
    color: 'fg.danger',
    borderColor: 'border.danger.muted',
    edge: token('colors.fg.error'),
  },
  INTEGRATION: { ...mutedMark, icon: GitBranchIcon },
};

export const AI_APPLICATION_EDGE_COLOR = token('colors.violet.9');

export const AI_COMPONENT_KINDS = new Set(Object.keys(AI_ATTACK_PATH_MARKS));
